import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { LanguageRounded } from "@mui/icons-material";
import SharedPreferences from "../utils/SharedPreferences";
import { STORAGE_KEYS } from "../utils/Constants";
import { supportedLngs } from "../i18n/config";
import { COLOR_MAIN } from "../utils/Colors";

export function LanguageSelectView() {
  const { i18n } = useTranslation();
  const [language, setLanguage] = React.useState(
    SharedPreferences.getString(STORAGE_KEYS.LANGUAGE) ?? i18n.resolvedLanguage
  );

  const handleChange = (event: SelectChangeEvent) => {
    event.preventDefault();
    const newLang = event.target.value as string;
    setLanguage(newLang);
    i18n.changeLanguage(newLang);
    SharedPreferences.setString(STORAGE_KEYS.LANGUAGE, newLang);
  };
  return (
    <Select
      sx={{
        fontFamily: "Rubik",
        borderRadius: 12,
        color: COLOR_MAIN,
        fontSize: 12,
        "& .MuiSelect-select": {
          paddingRight: 2,
          paddingLeft: 1.5,
          paddingTop: 1,
          paddingBottom: 1,
        },
        ".MuiOutlinedInput-notchedOutline": {
          borderColor: COLOR_MAIN,
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: COLOR_MAIN,
          borderWidth: 1,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: COLOR_MAIN,
        },
        ".MuiSvgIcon-root ": {
          fill: COLOR_MAIN + " !important",
          fontSize: 20,
        },
      }}
      inputProps={{
        MenuProps: {
          PaperProps: {
            sx: {
              borderRadius: 4,
            },
          },
        },
      }}
      value={language}
      onChange={handleChange}
      IconComponent={LanguageRounded}
    >
      {Object.entries(supportedLngs).map(([code, name]) => {
        return (
          <MenuItem key={code} sx={{ fontFamily: "Rubik" }} value={code}>
            {name}
          </MenuItem>
        );
      })}
    </Select>
  );
}
